import { createAsyncThunk } from "@reduxjs/toolkit"
import axios, { AxiosResponse } from "axios"
import { DEFAULT_ITEMS_PER_PAGE } from "../../constants/app"
import { setUpApprovedCentresPayload } from "../../models/enquiry"
import { TCreateAdminFormValues, TCreateAdminUserResponse, TGetAllAdminResponse, TUpdateAdminUserResponse } from "../../models/superadmin"
import { showNotificationAction } from "../application/slice"
import { setTokenAction } from "../auth/slice"
import { TProfileImageResponse, TProfilePicValues } from "../auth/types"
import { CentreDetailsPayload, TCreateCenterUserValues } from "../centers/types"
import { resetCentrePicAction, setAdminUserListAction, setAllActiveCentresAction, setAllActiveCentresListAction, setAllCandidateListAction, setAllPendingEnquiriesAction, setCandidateAdminComments, setCandidateReviewDataAction, setCentreDetailsAction, setCentrePicAction, setEnquiryDetailsAction, setJobAdderIdPopupShowAction, setTotalActiveCentresCountAction, setTotalCentreAdminCountAction, setTotalCentreUserCountAction, setTotalPendingCentresCountAction } from "./slice"
import { IAdminCandidateCommentsResponse, ICandidateResponse, TActivateCandidateBySuperAdminResponse, TCentreInactiveResponse, TCreateCentreUserResponse, TCreateNewCentreResponse, TDeclineEnquiryResponse, TDeclinemakeARequestResponse, TDeleteCandidateCommentsResponse, TGetAllActiveCentresListResponse, TGetAllActiveCentresResponse, TGetAllCandidatesResponse, TGetAllPendingEnquiriesResponse, TGetCentreDetailsResponse, TGetCentresUsersResponse, TGetEnquiryApproveResponse, TGetEnquiryDetailsResponse, TGetReferooDocumentResponse, TLoadingAllowance, TMakeCandidateDeactivateResponse, TOtherRequestsResponse, TPostCandidateCommentsResponse, TReopenStagePayload, TReopenStageResponse, TSetUpApprovedCentresResponse, TSubmitJobAdderIdResponse, TUpdateCentreDetailsResponse, TUpdateCentreUserResponse } from "./types"

/**
 * POST method
 * createAdminUsersThunk - Submit the form to create the admin users
 */
export const createAdminUsersThunk = createAsyncThunk(
    'superadmin/createAdminUsersThunk',
    async (data: TCreateAdminFormValues, { dispatch, rejectWithValue }) => {
      try {
        const response: AxiosResponse<TCreateAdminUserResponse> = await axios.post(`/v1/admin/users`, data)
        await dispatch(setTokenAction(response.data.data.token))
        // await dispatch(getAdminUsersThunk())
        return response.data
      } catch (err) {
        return rejectWithValue((err as any).response.data || err)
      }
    }
)

/**
 * GET method
 * getAdminUsersThunk - Get all the admin users
 */
export const getAdminUsersThunk = createAsyncThunk(    
  'superadmin/getAdminUsersThunk',
  async (
    { search = '', general_admin_page, super_admin_page, super_admins_per_page =10, general_admins_per_page =10, status="active" }: 
    { search?: string; general_admin_page?: string | number | null | Array<number>; super_admin_page?: string | number | null | Array<number>, super_admins_per_page: number, general_admins_per_page: number, status: string }, 
    { rejectWithValue, dispatch }
  ) => {
    try { 
        const response: AxiosResponse<TGetAllAdminResponse> = await axios.get(`/v1/admin/users`, {
          params: { search, general_admin_page: general_admin_page, super_admin_page: super_admin_page, super_admins_per_page: super_admins_per_page, general_admins_per_page: general_admins_per_page, status: status }
        })
        await dispatch(setTokenAction(response.data.data.token))
        await dispatch(setAdminUserListAction(response.data.data))
        return response.data
      } catch (err) {
        return rejectWithValue((err as any).response.data || err)
      }
    }
)

/**
 * GET method
 * getAdminUserDetailThunk - Get selected admin user details
 */
export const getAdminUserDetailThunk = createAsyncThunk(
    'superadmin/getAdminUserDetailThunk',
    async (data: { user_id: number }, { dispatch, rejectWithValue }) => {
      try {
        const response: AxiosResponse = await axios.get(`/v1/admin/users/${data?.user_id}`)
        return response.data
      } catch (err) {
        return rejectWithValue((err as any).response.data || err)
      }
    }
)

/**
 * PUT method
 * updateAdminUserDetailThunk - Update the selected admin user details
 */
export const updateAdminUserDetailThunk = createAsyncThunk(
  'superadmin/updateAdminUserDetailThunk',
  async (data: { candidate_id: number }, { dispatch, rejectWithValue }) => {
    try {
      const response: AxiosResponse<TUpdateAdminUserResponse> = await axios.put(`/v1/admin/users/${data?.candidate_id}`, data)
      await dispatch(setTokenAction(response.data.data.token))
      // await dispatch(getAdminUsersThunk()) 
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/**
 * GET method
 * getAllCandidatesThunk - To get all the centers users list
 */

export const getAllCandidatesThunk = createAsyncThunk(    
  'superadmin/getAllCandidatesThunk',
  async (
    { keyword = '', pending_page, compliance_alerts_page, approved_page, pending_per_page, compliance_alerts_per_page, approved_per_page, sort_by="first_name", sort_order = "asc", pending_emp_sort_by="first_name", pending_emp_sort_order = "asc", compliance_alerts_sort_by="first_name", compliance_alerts_sort_order = "asc" }: 
    { keyword?: string; pending_page?: string | number | null | Array<number>; compliance_alerts_page?: string | number | null | Array<number>; approved_page?: string | number | null | Array<number>, pending_per_page: number, compliance_alerts_per_page: number; approved_per_page: number; sort_by: string; sort_order: string; pending_emp_sort_by: string; pending_emp_sort_order: string, compliance_alerts_sort_by: string; compliance_alerts_sort_order: string }, 
    { rejectWithValue, dispatch }
  ) => {
    try {
      const response: AxiosResponse<TGetAllCandidatesResponse> = await axios.get(`/v1/admin/candidates`, {
        params: { keyword, pending_page: pending_page, compliance_alerts_page: compliance_alerts_page, approved_page: approved_page, pending_per_page: pending_per_page, compliance_alerts_per_page: compliance_alerts_per_page, approved_per_page: approved_per_page, sort_by: sort_by, sort_order: sort_order, pending_emp_sort_by: pending_emp_sort_by, pending_emp_sort_order: pending_emp_sort_order, compliance_alerts_sort_by: compliance_alerts_sort_by, compliance_alerts_sort_order: compliance_alerts_sort_order }
      });
      await dispatch(setTokenAction(response.data.data.token));
      await dispatch(setAllCandidateListAction(response.data.data?.[0]));
      return response.data;
    } catch (err) {
      return rejectWithValue((err as any).response.data || err);
    }
  }
);

/**
 * GET method
 * getCandidateData - Getting candidate data for review popup
 */
export const getCandidateData = createAsyncThunk(
  'superadmin/getCandidateData',
  async (data: { candidate_id: string | undefined }, { dispatch, rejectWithValue }) => {
    try {
      const response: AxiosResponse<ICandidateResponse> = await axios.get(`/v1/admin/candidates/${data?.candidate_id}`)
      await dispatch(setTokenAction(response.data.data.token))
      await dispatch(setCandidateReviewDataAction(response.data.data?.[0]))
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/**
 * GET method
 * getAllPendingEnquiriesThunk - To get all the pending enquiries list
 */
export const getAllPendingEnquiriesThunk = createAsyncThunk(    
  'superadmin/getAllPendingEnquiriesThunk',
  async (
    { keyword = '', page,  per_page }: 
    { keyword?: string; page?: string | number | null | Array<number>; per_page: number }, 
    { rejectWithValue, dispatch }
  ) => {
    try { 
      const response: AxiosResponse<TGetAllPendingEnquiriesResponse> = await axios.get(`/v1/admin/enquiries`, {
        params: { keyword, page: page, per_page: per_page }
      })
      await dispatch(setTokenAction(response.data.data.token))
      await dispatch(setAllPendingEnquiriesAction(response.data.data.enquiries))
      await dispatch(setTotalPendingCentresCountAction(response.data.data.total_enquiries))
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/**
 * POST method
 * updateBypassComplianceCheckThunk - Update bypass compliance check status and reason for a candidate
 */
export const updateBypassComplianceCheckThunk = createAsyncThunk(
  'superadmin/updateBypassComplianceCheckThunk',
  async (
    data: { candidate_id: number; bypass_compliance_check: boolean; complaince_check_bypass_reason: string },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const response: AxiosResponse = await axios.post(`/v1/admin/candidates/bypass-compliance-check`, data)
      await dispatch(setTokenAction(response.data.data.token))
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/**
 * POST method
 * clearStage2ReopenThunk - Clear stage 2 reopen data once all compliance documents are complete
 */
export const clearStage2ReopenThunk = createAsyncThunk(
  'superadmin/clearStage2ReopenThunk',
  async (data: { candidate_id: number; candidate_uuid?: string }, { dispatch, rejectWithValue }) => {
    try {
      const response: AxiosResponse = await axios.post(`/v1/admin/candidates/clear-stage2-reopen`, { candidate_id: data.candidate_id })
      await dispatch(setTokenAction(response.data.data.token))
      if (data.candidate_uuid) {
        await dispatch(getCandidateData({ candidate_id: data.candidate_uuid }))
      }
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/**
 * POST method
 * activateCandidateBySuperAdmin - Submit the form to activate a candidate
 */
export const activateCandidateBySuperAdmin = createAsyncThunk(
  'superadmin/activateCandidateBySuperAdmin',
  async (data: {FormData: FormData, currentCandidateId: number, currentCandidateUUID: string}, { dispatch, rejectWithValue }) => {
    try {
      const response: AxiosResponse<TActivateCandidateBySuperAdminResponse> = await axios.post(`/v1/admin/candidates/activate`, data?.FormData)
      await dispatch(setTokenAction(response.data.data.token))
      await dispatch(getCandidateData({ candidate_id: data?.currentCandidateUUID }))
     
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/**
 * GET method
 * getCandidateComments - Getting candidate data for review popup
 */
export const getCandidateComments = createAsyncThunk(
  'superadmin/getCandidateComments',
  async (data: { candidate_id: number }, { dispatch, rejectWithValue }) => {
    try {
      const response: AxiosResponse<IAdminCandidateCommentsResponse> = await axios.get(`/v1/admin/candidates/${data?.candidate_id}/comments`)
      await dispatch(setTokenAction(response.data.data.token))
      await dispatch(setCandidateAdminComments(response.data.data))
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/**
 * GET method
 * getEnquiryDetailsThunk - To get and review the enquiry details
 */
export const getEnquiryDetailsThunk = createAsyncThunk(    
  'superadmin/getEnquiryDetailsThunk',
  async (data: { enquiry_id: number }, { rejectWithValue, dispatch }) => {
    try {
      const response: AxiosResponse<TGetEnquiryDetailsResponse> = await axios.get(`/v1/admin/enquiries/${data?.enquiry_id}`)
      await dispatch(setTokenAction(response.data.data.token))
      await dispatch(setEnquiryDetailsAction(response.data.data))
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/**
 * POST method
 * postCandidateCommentsThunk - Submit the form to create the admin users
 */
export const postCandidateCommentsThunk = createAsyncThunk(
  'superadmin/postCandidateCommentsThunk',
  async (data: { currentCandidateId: number, comment: string}, { dispatch, rejectWithValue }) => {
    try {
      const response: AxiosResponse<TPostCandidateCommentsResponse> = await axios.post(`/v1/admin/candidates/${data?.currentCandidateId}/comments`, data)
      await dispatch(setTokenAction(response.data.data.token))
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/**
 * GET method
 * getEnquiryApproveThunk - To approve the enquiry
 */
export const getEnquiryApproveThunk = createAsyncThunk(    
  'superadmin/getEnquiryApproveThunk',
  async (data: { enquiry_id: number }, { rejectWithValue, dispatch }) => {
    try {
      const response: AxiosResponse<TGetEnquiryApproveResponse> = await axios.get(`/v1/admin/centres/activate/${data?.enquiry_id}`)
      await dispatch(setTokenAction(response.data.data.token))
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/**
 * GET method
 * getCentresUsersThunk - To get all the centers users list
 */
export const getCentresUsersThunk = createAsyncThunk(
  'superadmin/getCentresUsersThunk',
  async (
    { keyword = '', centre_admin_page, centre_user_page, centre_admin_per_page, centre_user_per_page, status="", centre_id, centre_admin_sort_by= "first_name", centre_admin_sort_order= "asc", centre_user_sort_by= "first_name", centre_user_sort_order= "asc" }: 
    { keyword?: string; centre_admin_page?: string | number | null | Array<number>; centre_user_page?: string | number | null | Array<number>, centre_admin_per_page: number; centre_user_per_page: number; status: string; centre_id?: string | number | null | Array<number>; centre_admin_sort_by: string; centre_admin_sort_order: string; centre_user_sort_by: string; centre_user_sort_order: string }, 
    { rejectWithValue, dispatch }
  ) => {
    try { 
      const centreIdParam = Array.isArray(centre_id) ? centre_id?.length > 0 ?'['+centre_id.join(',')+']' : '' : centre_id;
      const response: AxiosResponse<TGetCentresUsersResponse> = await axios.get(`/v1/admin/centres/users`, {
        params: { keyword, centre_admin_page: centre_admin_page, centre_user_page: centre_user_page, centre_admin_per_page: centre_admin_per_page ,centre_user_per_page: centre_user_per_page, status: status, centre_id: centreIdParam, centre_admin_sort_by: centre_admin_sort_by, centre_admin_sort_order: centre_admin_sort_order, centre_user_sort_by: centre_user_sort_by, centre_user_sort_order: centre_user_sort_order}
      });
      await dispatch(setTokenAction(response.data.data.token));
      await dispatch(setTotalCentreAdminCountAction(response.data.data.users.total_centre_admin));
      await dispatch(setTotalCentreUserCountAction(response.data.data.users.total_centre_user));
      // await dispatch(getAllActiveCentresThunk());
      return response.data;
    } catch (err) {
      return rejectWithValue((err as any).response.data || err);
    }
  }
);

/**
 * GET method
 * getAllActiveCentresListThunk - Get all the centre admin/centre users
 */
export const getAllActiveCentresListThunk = createAsyncThunk(    
  'superadmin/getAllActiveCentresListThunk',
  async (
    { keyword = '', page = 1, per_page = DEFAULT_ITEMS_PER_PAGE, paginate = true, sort_by="first_name", sort_order="asc" }: 
    { keyword?: string; page?: string | number | null | Array<number>; per_page?: number; paginate?: boolean; sort_by: string; sort_order: string }, 
    { rejectWithValue, dispatch }
  ) => {
    try {
      const response: AxiosResponse<TGetAllActiveCentresListResponse> = await axios.get('/v1/admin/centres?paginate=1', {
        params: { keyword, page: page || 1, per_page: per_page || DEFAULT_ITEMS_PER_PAGE, sort_by: sort_by, sort_order: sort_order }
      });
      await dispatch(setTokenAction(response.data.data.token));
      await dispatch(setAllActiveCentresListAction(response.data.data.centres));
      await dispatch(setTotalActiveCentresCountAction(response.data.data.total_centres));
      return response.data;
    } catch (err) {
      return rejectWithValue((err as any).response.data || err);
    }
  }
);

/**
 * GET method
 * getAllActiveCentresThunk - Get all the centres without pagination
 */
export const getAllActiveCentresThunk = createAsyncThunk(    
  'superadmin/getAllActiveCentresThunk',
  async (
    { keyword = '', page = 1, per_page = DEFAULT_ITEMS_PER_PAGE, paginate = true }: 
    { keyword?: string; page?: string | number | null | Array<number>; per_page?: number; paginate?: boolean }, 
    { rejectWithValue, dispatch }
  ) => {
    try { 
      const response: AxiosResponse<TGetAllActiveCentresResponse> = await axios.get('/v1/admin/centres', {
        params: { keyword, page: page || 1, per_page: per_page || DEFAULT_ITEMS_PER_PAGE }
      });
      await dispatch(setTokenAction(response.data.data.token));
      await dispatch(setAllActiveCentresAction(response.data.data.centres));
      await dispatch(setTotalActiveCentresCountAction(response.data.data.total_centres));
      return response.data;
    } catch (err) {
      return rejectWithValue((err as any).response.data || err);
    }
  }
);


/**
 * DELETE method
 * declineEnquiryThunk - To decline the enquiry
 */
export const declineEnquiryThunk = createAsyncThunk(    
  'superadmin/declineEnquiryThunk',
  async (data: { enquiry_id: number }, { rejectWithValue, dispatch }) => {
    try {
      const response: AxiosResponse<TDeclineEnquiryResponse> = await axios.delete(`/v1/admin/enquiries/${data?.enquiry_id}`)
      await dispatch(setTokenAction(response.data.data.token))
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/**
 * GET method
 * centreInactiveThunk - To make inactive the centre
 */
export const centreInactiveThunk = createAsyncThunk(    
  'superadmin/centreInactiveThunk',
  async (data: { centre_id: number }, { rejectWithValue, dispatch }) => {
    try {
      const response: AxiosResponse<TCentreInactiveResponse> = await axios.get(`/v1/admin/centres/deactivate/${data?.centre_id}`)
      await dispatch(setTokenAction(response.data.data.token))
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/**
 * GET method
 * getCentreDetailsThunk - To get the centre details
 */
export const getCentreDetailsThunk = createAsyncThunk(    
  'superadmin/getCentreDetailsThunk',
  async (data: { centre_id: number }, { rejectWithValue, dispatch }) => {
    try {
      const response: AxiosResponse<TGetCentreDetailsResponse> = await axios.get(`/v1/admin/centres/${data?.centre_id}`)
      await dispatch(setTokenAction(response.data.data.token))
      await dispatch(setCentreDetailsAction(response.data.data))
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/**
 * PUT method
 * updateCentreDetailsThunk - Update the selected centre details
 */
export const updateCentreDetailsThunk = createAsyncThunk(
  'superadmin/updateCentreDetailsThunk',
  async (data: CentreDetailsPayload, { dispatch, rejectWithValue }) => {
    try {
      const response: AxiosResponse<TUpdateCentreDetailsResponse> = await axios.put(`/v1/admin/centres/${data?.id}`, data)
      await dispatch(setTokenAction(response.data.data.token))
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/**
 * DELETE method
 * DeleteCandidateCommentsThunk - Delete the candidate comments from super admin
 * @param data - The data to be sent in the request body.
 */
export const DeleteCandidateCommentsThunk = createAsyncThunk(
  'superadmin/DeleteCandidateCommentsThunk',
  async (data: { currentCandidateId: number, commentId: number}, { dispatch, rejectWithValue }) => {
    try {
      const response: AxiosResponse<TDeleteCandidateCommentsResponse> = await axios.delete(`/v1/admin/candidates/${data?.currentCandidateId}/comments/${data?.commentId}`)
      await dispatch(setTokenAction(response.data.data.token))
      await dispatch(getCandidateComments({ candidate_id: 1 }))
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/**
 * POST method
 * createNewCentreThunk - Submit the form to create the admin users
 */
export const createNewCentreThunk = createAsyncThunk(
  'superadmin/createNewCentreThunk',
  async (data: CentreDetailsPayload, { dispatch, rejectWithValue }) => {
    try {
      const response: AxiosResponse<TCreateNewCentreResponse> = await axios.post(`/v1/admin/centres`, data)
      await dispatch(setTokenAction(response.data.data.token))
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/**
 * POST method
 * createCentreUserThunk - Submit the form to create the admin users
 */
export const createCentreUserThunk = createAsyncThunk(
  'superadmin/createCentreUserThunk',
  async (data: TCreateCenterUserValues, { dispatch, rejectWithValue }) => {
    try {
      const response: AxiosResponse<TCreateCentreUserResponse> = await axios.post(`/v1/admin/centres/users`, data)
      await dispatch(setTokenAction(response.data.data.token))
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/**
 * PUT method
 * updateCentreUserThunk - Update the selected centre user details
 */
export const updateCentreUserThunk = createAsyncThunk(
  'superadmin/updateCentreUserThunk',
  async (data: { user_id: number }, { dispatch, rejectWithValue }) => {
    try {
      const response: AxiosResponse<TUpdateCentreUserResponse> = await axios.put(`/v1/admin/centres/users/${data?.user_id}`, data)
      await dispatch(setTokenAction(response.data.data.token))
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/**
 * POST method
 * uploadsCentrePictureThunk - Upload the profile picture
 */
export const uploadsCentrePictureThunk = createAsyncThunk(
  'app/uploadsCentrePictureThunk',
  async (data: FormData | TProfilePicValues, { dispatch, rejectWithValue }) => {
    try {
      const response: AxiosResponse<TProfileImageResponse> = await axios.post(`/v1/admin/centres/profile-image`, data)
      await dispatch(setTokenAction(response.data.data.token))
      await dispatch(resetCentrePicAction())
      await dispatch(setCentrePicAction(response.data.data))
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/***
 * POST method
 * makeCandidateInactive - Update the selected candidate inactive
 * */
export const makeCandidateInactive = createAsyncThunk(
  'superadmin/makeCandidateInactive',
  async (data: {candidate_id: number}, { dispatch, rejectWithValue }) => {
    try {
      const response: AxiosResponse<TMakeCandidateDeactivateResponse> = await axios.post(`/v1/admin/candidates/deactivate`, data)
      await dispatch(setTokenAction(response.data.data.token))
      return response.data.data; 
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/***
 * POST method
 * setUpApprovedCentresThunk - setup enquired centres and invite centre admin
 * */
export const setUpApprovedCentresThunk = createAsyncThunk(
  'superadmin/setUpApprovedCentresThunk',
  async (data: setUpApprovedCentresPayload, { dispatch, rejectWithValue }) => {
    try {
      const response: AxiosResponse<TSetUpApprovedCentresResponse> = await axios.post(`/v1/admin/centres/activate`, data)
      await dispatch(setTokenAction(response.data.data.token))
      return response.data; 
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/**
 * POST method
 * Decline the request from candidate to update profile
 */
export const declineMakeARequestThunk = createAsyncThunk(
  'superadmin/declineMakeARequestThunk',
  async (data: {request_id: string, request_from: string}, { dispatch, rejectWithValue }) => {
    try {

      const response: AxiosResponse<TDeclinemakeARequestResponse> = await axios.post(`/v1/candidates/profile-edit-requests-status-update/${data?.request_id}/rejected/${data.request_from}`, data)
      await dispatch(setTokenAction(response.data.data.token))
      return response.data.data; 
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/**
 * POST method
 * profileEditRequestStatusThunk – update a candidate‑profile edit‑request status
 *   @route   /v1/candidates/profile-edit-requests-status-update/{request_id}/{status}
 */
export const profileEditRequestStatusThunk = createAsyncThunk(
  "superadmin/profileEditRequestStatusThunk",
  async (
    data: { request_id: string; request_from: string},
    { dispatch, rejectWithValue }
  ) => {
    const { request_id, request_from } = data;
    const status = 'approved';
    try {
      const response: AxiosResponse<any> = await axios.post(
        `/v1/candidates/profile-edit-requests-status-update/${request_id}/${status}/${request_from}`
      );

      // store fresh JWT if backend returns one
      if (response.data?.data?.token) {
        await dispatch(setTokenAction(response.data.data.token));
      }

      return response.data.data; // return the API payload
    } catch (err) {
      return rejectWithValue((err as any).response?.data || err);
    }
  }
);

/**
 * POST method
 * otherRequestsThunk - To make Active/Inactive, resend/cancel invitation
 */
export const otherRequestsThunk = createAsyncThunk(
  "superadmin/otherRequestsThunk",
  async (
    data: { user_uuid: string; action: string },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const response: AxiosResponse<TOtherRequestsResponse> = await axios.post(
        `/v1/admin/users/${data?.user_uuid}/action`,
        { action: data.action }
      );
      await dispatch(setTokenAction(response.data.data.token));
      return response.data.data;
    } catch (err) {
      return rejectWithValue((err as any).response.data || err);
    }
  }
);


export const saveCandidateLoadAllowanceThunk = createAsyncThunk(
  'superadmin/saveCandidateLoadAllowanceThunk',
  async (data: { candidate_id: number | null, loading_amount: number | null}, { dispatch, rejectWithValue }) => {
    try {
      const response: AxiosResponse<TLoadingAllowance> = await axios.post(`/v1/admin/candidates/loading`, data)
      await dispatch(setTokenAction(response.data.data.token))
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/**
 * POST method
 * submitJobAdderIdThunk - Submit the job adder id for each candidate
 */
export const submitJobAdderIdThunk = createAsyncThunk(
  'superadmin/submitJobAdderIdThunk',
  async (data: {jobAdderId: string | null, candidate_uuid: string | null}, { dispatch, rejectWithValue }) => {
    try {
      const response: AxiosResponse<TSubmitJobAdderIdResponse> = await axios.post(`/v1/admin/job-adder-id`, data)
      await dispatch(setTokenAction(response.data.data.token))
      dispatch(showNotificationAction("Submitted"))
      await dispatch(setJobAdderIdPopupShowAction({
          showPopupModal: false,
          candidateUuid: null
      }));
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/**
 * POST method
 * resendVerificationEmailThunk - Resend verification email to a candidate
 */
export const resendVerificationEmailThunk = createAsyncThunk(
  'superadmin/resendVerificationEmailThunk',
  async (data: { candidateUuid: string }, { rejectWithValue, dispatch }) => {
    try {
      const response: AxiosResponse = await axios.post(`/v1/admin/candidates/${data.candidateUuid}/resend-verification-email`)
      await dispatch(setTokenAction(response.data.data.token))
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/**
 * GET method
 * getReferooDocumentThunk - To get and review the enquiry details
 */
export const getReferooDocumentThunk = createAsyncThunk(    
  'superadmin/getReferooDocumentThunk',
  async (data: { user_uuid: string }, { rejectWithValue, dispatch }) => {
    try {
      const response: AxiosResponse<TGetReferooDocumentResponse> = await axios.get(`/v1/referoo/candidate/${data?.user_uuid}/documents`)
      await dispatch(setTokenAction(response.data.data.token))
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)

/**
 * POST method
 * reopenStageThunk - Reopen a previously submitted or approved stage for a candidate
 */
export const reopenStageThunk = createAsyncThunk(
  'superadmin/reopenStageThunk',
  async (data: TReopenStagePayload, { dispatch, rejectWithValue }) => {
    try {
      const response: AxiosResponse<TReopenStageResponse> = await axios.post(`/v1/admin/candidates/reopen-stage`, data)
      await dispatch(setTokenAction(response.data.data.token))
      dispatch(showNotificationAction(response.data.message || `Stage ${data.stage_number} reopened successfully`))
      return response.data
    } catch (err) {
      const error = (err as any).response?.data || err
      dispatch(showNotificationAction(error.message || 'Failed to reopen stage'))
      return rejectWithValue(error)
    }
  }
)

/**
 * POST method
 * updateStepBypassReasonThunk - Save step bypass reason for a candidate
 */
export const updateStepBypassReasonThunk = createAsyncThunk(
  'superadmin/updateStepBypassReasonThunk',
  async (
    data: { candidate_id: number; bypass_type: string; reason: string },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const response: AxiosResponse = await axios.post(`/v1/admin/candidates/step-bypass-reason`, data)
      await dispatch(setTokenAction(response.data.data.token))
      return response.data
    } catch (err) {
      return rejectWithValue((err as any).response.data || err)
    }
  }
)